"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var testHelpers_1 = require("./testHelpers");
Object.defineProperty(exports, "createMockOfClass", { enumerable: true, get: function () { return testHelpers_1.createMockOfClass; } });
//# sourceMappingURL=index.js.map